import styled from 'styled-components';
import Button from '@mui/material/Button';

export default styled(Button)`
  ${({ theme }) => `
    background-color: ${theme.palette.primary.main};
    color: ${theme.palette.primary.contrastText};

    &:hover {
      background-color: ${theme.palette.primary.main};
    }
  `}
`;
